const Users = () => import('@/views/User/users.vue')
const UserGrade = () => import('@/views/User/user-grade.vue')
const UserCash = () => import('@/views/User/user-cash.vue')
const UserCommission = () => import('@/views/User/user-commission.vue')
const UserCoupon = () => import('@/views/User/user-coupon.vue')
const UserCouponCar = () => import('@/views/User/user-coupon-car.vue')
const Staff = () => import('@/views/User/staff.vue')
const StaffSts = () => import('@/views/User/staff-sts.vue')
const OilGun = () => import('@/views/User/oil-gun.vue')

const router = [
  {
    meta: { title: '会员列表', route: 'users_index' },
    path: 'users',
    name: 'users',
    component: Users
  },
  {
    meta: { title: '优惠券记录', route: 'user_coupon_index' },
    path: 'user-coupon',
    name: 'user-coupon',
    component: UserCoupon
  },
  {
    meta: { title: '洗车券记录', route: 'user_coupon_car' },
    path: 'user-coupon-car',
    name: 'user-coupon-car',
    component: UserCouponCar
  },
  {
    meta: { title: '等级管理', route: 'user_grade_index' },
    path: 'user-grade',
    name: 'user-grade',
    component: UserGrade
  },
  {
    meta: { title: '提现列表', route: 'user_cash_index' },
    path: 'user-cash',
    name: 'user-cash',
    component: UserCash
  },
  {
    meta: { title: '佣金记录', route: 'user_commission_index' },
    path: 'user-commission',
    name: 'user-commission',
    component: UserCommission
  },
  {
    meta: { title: '员工列表', route: 'staff_index' },
    path: 'staff',
    name: 'staff',
    component: Staff
  },
  {
    meta: { title: '员工统计', route: 'staff_sts_index' },
    path: 'staff-sts',
    name: 'staff-sts',
    component: StaffSts
  },
  {
    meta: { title: '油枪列表', route: 'oil_gun_index' },
    path: 'oil-gun',
    name: 'oil-gun',
    component: OilGun
  }
]
module.exports = { router }
